// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDpuFgGaE9kQZxvL6l7HvIEAgerZFD07Nw",
  authDomain: "nabidkawebovychstranek.firebaseapp.com",
  projectId: "nabidkawebovychstranek",
  storageBucket: "nabidkawebovychstranek.appspot.com",
  messagingSenderId: "1070302699021",
  appId: "1:1070302699021:web:2e17e70ae7010a3e3dff44",
  measurementId: "G-4H9NN9SDEC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };